import { makeAutoObservable, runInAction } from 'mobx'
import { AxiosError } from 'axios'
import { RequestLoadData } from 'shared/api/lib'
import { logger } from 'shared/lib'
import { toastStore } from 'shared/ui'
import { InboxesApi } from 'entities/Inbox'
import { Inbox } from 'entities/Inbox/model/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'

export class InboxesTeamStore {
  private _inboxesMap: Map<number | string, Inbox> = new Map()
  private _selectedItemId: Null<number> = null

  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
    this.init()
  }

  init = async () => {
    await this.fetchAllInboxes()
    runInAction(() => {
      this._selectedItemId = this._entities.organizationStore.fallbackTeamId
    })
  }

  private _status = new RequestLoadData({
    requestCallback: async ({ cancelRequest }) => {
      const { data } = await InboxesApi.getTeamsAll(undefined, {
        cancelToken: cancelRequest.token,
      })
      data.forEach((item) => {
        if (item.type !== 'inbox') return
        this._inboxesMap.set(item.id, new Inbox(item, this._entities))
      })
    },
  })

  fetchAllInboxes = () => this._status.blockingLoadData()

  updateFallbackTeamId = async (itemId: number) => {
    try {
      await this._entities.organizationStore.updateFallbackTeamId(itemId)
      runInAction(() => {
        this._selectedItemId = itemId
      })
    } catch (e) {
      logger.error(e)
      if (e instanceof AxiosError) {
        if (e.response?.status === 403) {
          toastStore.add({
            type: 'error',
            title: "You don't have permission to change the fallback inbox. Contact your admin.",
          })
        }
      }
    }
  }

  get selectedInboxId() {
    return this._selectedItemId
  }

  get inboxes() {
    return Array.from(this._inboxesMap.values()).filter((inbox) => !inbox.isRCS)
  }

  get status() {
    return this._status.status
  }
}
